export const StorageAccessToken = "local_access_token"
export const MainSystemLoginUrl = "https://app.parentwiser.com/login-with-token"